define([
    'riot'
], function (
    riot
) {
    'use strict';

    function TriotException(message) {
        this.message = message;
        this.name = 'TriotException';
    }

    // Inherit riot's api
    var triot = Object.create(riot);

    // Expose a global observable as triot.bus
    // Used by non-riot components, such as data-services
    Object.defineProperties(triot, {
        bus: {
            value: triot.observable(),
            enumerable: false,
            writable: false,
            configurable: false
        }
    });

    // Add the global bus to all riot components
    // so they can reach it as this.bus, ie this.bus.on('eventName' .. )
    // No more need to pass the bus around and no
    // more "var bus = riot.observable()" on different places
    triot.mixin({
        init: function() {
            this.on('before-mount', function () {
                Object.defineProperties(this, {
                    bus: {
                        value: triot.bus,
                        enumerable: false,
                        writable: false,
                        configurable: false
                    }
                });
            });
        }
    });

    // Triot's mount functionality doesn't break if we try to mount
    // a component that doesn't exist. We add a safeMount function
    // that throws if number of mounted components < 1.
    function safeMount (selector, tagName, opts) {
        var mountedComponents = triot.mount(selector, tagName, opts);
        if (mountedComponents.length < 1) {
            throw new TriotException('No component mounted with selector: ' + selector);
        }
        return mountedComponents;
    }

    // Expose safeMount as triot.safeMount
    Object.defineProperties(triot, {
        safeMount: {
            value: safeMount,
            enumerable: false,
            writable: false,
            configurable: false
        }
    });

    // Function to unmount all components
    function unmountAll (keepRootTag) {
        var unmounted = 0;
        while (triot.vdom.length > 0) {
            triot.vdom[0].unmount(keepRootTag);
            unmounted++;
        }
        return unmounted;
    }

    function setupTeardown () {
        triot.bus.on('triot:teardown', function (payload) {
            payload = payload || {};
            var keepRootTag = !!payload.keepRootTag;
            unmountAll(keepRootTag);
            triot.bus.off('*');

            setupTeardown();
        });
    }

    setupTeardown();

    return triot; // So this is basically riot, but with the extra global bus attached
});


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/libs/triot.js